<div class="tw-bg-white">
  <!-- Calendar Strip -->
  @if (productInstructions?.length) {
    <div class="tw-sticky tw-top-12 tw-z-[5]">
      <div class="tw-flex tw-justify-between tw-bg-gray-100 tw-h-16 tw-text-center tw-py-2 tw-px-6">
        @for (day of weekArray; track day) {
          <div class="" (click)="onDateSelect(day)">
            @if (+day?.date !== unChangedTodayDay) {
              <p class="tw-font-body tw-text-200 tw-capitalize"
                [ngClass]="{'tw-opacity-50 tw-text-gray-800': !day.isSelected, 'tw-text-teal-600': day.isSelected}">
                {{ day?.dayValue }}
              </p>
            }
            @if (+day?.date === unChangedTodayDay) {
              <p class="tw-font-body tw-text-200 tw-capitalize" [ngClass]="{'tw-opacity-50 tw-text-gray-800': !day.isSelected, 'tw-text-teal-600': day.isSelected}">
                Today
              </p>
            }
            <p class="tw-font-body tw-text-300 tw-uppercase tw-mt-1 tw-flex tw-justify-center tw-items-center">
              <span class="tw-w-6 tw-aspect-square tw-rounded-full tw-flex tw-justify-center tw-items-center"
              [ngClass]='{"tw-bg-teal-600  tw-text-white": day.isSelected, "tw-opacity-50 tw-text-gray-800": !day.isSelected}'>{{ day?.date }}</span>
            </p>
          </div>
        }
      </div>
    </div>
  }

  <div class="tw-mt-2"></div>

  <!-- Instructions Cards -->
  <section class="tw-flex tw-flex-col tw-gap-1 tw-p-4 tw-pb-0 tw-bg-gray-100">
    @for (productInstruction of productInstructions; track productInstruction.product.title) {
      <app-instruction-card
        [item]="productInstruction"
        [isDayTime]="isDayTime"
        [todayDayVal]="todayDayVal"
        [days]="days"
        [user]="user"
        [userLanguage]="userLanguage"
        (playButtonClick)="onPlayButtonClick($event)"
        [fromOthersSection]="true"
        >
      </app-instruction-card>
    }
  </section>
</div>

<!-- Video Player -->
<div class="video-container tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-hidden tw-z-50">
  <div class="tw-bg-black tw-absolute tw-inset-0"></div>
  <video class="tw-h-full tw-w-full tw-object-contain tw-max-w-full tw-max-h-full tw-relative tw-z-10" #videoPlayer controls="controls"></video>
  <button class="tw-absolute tw-top-2 tw-right-1 tw-rounded-full tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-end tw-text-white tw-font-bold tw-text-xl tw-z-10 close-video-button" (click)="closeVideo()">
    <svg class="tw-h-6 tw-w-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path>
    </svg>
  </button>
</div>